import { START_LOADING, STOP_LOADING } from "../Types/loader";

const initialState = {
  showLoader: false,
};

export function loaderReducer(state = initialState, action) {
  switch (action.type) {
    case START_LOADING: {
      return { ...state, showLoader: true };
    }
    case STOP_LOADING: {
      return { ...state, showLoader: false };
    }
    default:
      return state;
  }
}
